import { Button, Modal, ModalBody, ModalHeader, Spinner } from "reactstrap";
import { withTranslation } from "react-i18next";
import DtsDataSelectInput from "./DtsDataSelectInput";
import { getduplicateRequest } from "store/deduplicate/action";
import { Action, ThunkDispatch } from "@reduxjs/toolkit";
import { useDispatch } from "react-redux";

const ReviewModal = ({ t, show, onCloseClick, setIsPropertyOpen, model, pagination, setSelectedFields, dataLoading,setInnitial, selectedFields}: any) => {
    const dispatch: ThunkDispatch<any, null, Action<string>> = useDispatch();

    const handleselected = (option: any) => {        
        if (!option?.length) setSelectedFields([])  ; 
        setSelectedFields(option)   
    }

    const onSearchDuplicate = () => { 
        const keyString = selectedFields.map((item: any) => item.value).join(',');   
        const handleSuccess = () => {     
            setIsPropertyOpen(false)
            setInnitial(false)
        }  
        dispatch(getduplicateRequest(model, keyString, 0, pagination?.size, handleSuccess));      
    }

    return (
        <Modal backdrop={'static'} isOpen={show} toggle={onCloseClick} centered={true} backdropClassName={'bg-opacity-10'}>
            <ModalHeader className="p-3 offcanvas-header-dark d-flex flex-row justify-content-between align-items-center bg-primary" toggle={onCloseClick}>
                <span className='text-light'>{t("common.modals.select_fields_check_duplicate_record")}</span>
            </ModalHeader>
            <ModalBody className='p-5 py-2'>
                <div className="mt-1 vstack gap-2">
                    <div>
                        <DtsDataSelectInput
                            placeholder={'Select Field name'}
                            onChange={(option : any) => handleselected(option)}
                            label={'Field name'}
                            model={model || ''}
                            value={selectedFields}
                        />
                    </div>                  
                    <div className="hstack gap-2 justify-content-center">
                        <Button color='primary' disabled={!selectedFields?.length || dataLoading} className="btn btn-primary" onClick={() => onSearchDuplicate()}>
                            {dataLoading ? <Spinner size="sm" type="grow" className="flex-shrink-0" role="status"> {t("common.table.loading")} </Spinner>: null }{" "}                   
                       
                            {t("common.offcanvas.search_duplicates")}
                        </Button>
                        <Button color="danger" onClick={() => onCloseClick()} outline>
                            {t("common.offcanvas.cancel")}
                        </Button>
                    </div>
                </div>
            </ModalBody>
        </Modal>
    ) as unknown as JSX.Element;
};

export default withTranslation()(ReviewModal);